import axios from 'axios';
import {apiBaseUrl} from "../../../helpers/UrlHelper";
import { loginToken } from '../../../helpers/LocalStorageHelper'
import {handleError, handleSuccess} from '../../../helpers/ErrorHelper'
import store from "../../../Store";
import getSiteStatus from "../sites/site_status_get";
import {handle422error} from "../../../helpers/ErrorHelper"

function _success(success)
{
  return { type: 'POST_CUSTOM_GENERATE_SSL_SUCCESS', success };
}
function _error(error)
{
  return { type: 'POST_CUSTOM_GENERATE_SSL_ERROR', error };
}
function _processing(processing)
{
  return { type: 'POST_CUSTOM_GENERATE_SSL_PROCESSING', processing };
}

function createGenerateCustomSsl(id)
{
  return ( dispatch, getState ) =>
  {
    dispatch(_processing(true));
    dispatch(_error(null));
    let {organizationDashboard} = getState();
    let org_id = organizationDashboard.data.organization_id;

    axios({
      url: apiBaseUrl(`admin/organizations/${org_id}/sites/${id}/generate-custom-Ssl`),
      method: "post",
      dataType: 'json',
      headers: {
        'Authorization': 'Bearer ' + loginToken()
      }
    })
      .then(function(res){
        dispatch(_success(res));
        dispatch(_processing(false));
        handleSuccess( res )
        store.dispatch(getSiteStatus(id))
      })
      .catch(function(error){
        dispatch(_error(error));
        dispatch(_processing(false));
        handleError( error )
        if (error.response && error.response.status === 422) {
          handle422error( error.response.data.errors )
        }
      });

  }
}


export default createGenerateCustomSsl;